import api from '../utils/api';

const facilitiesService = {
  summary: () => api.get('/api/facilities/summary'),
  assets: () => api.get('/api/facilities/assets'),
  createAsset: (data) => api.post('/api/facilities/assets', data),
  updateAsset: (id, data) => api.patch(`/api/facilities/assets/${id}`, data),
  archiveAsset: (id) => api.delete(`/api/facilities/assets/${id}`),
  requests: () => api.get('/api/facilities/requests'),
  createRequest: (data) => api.post('/api/facilities/requests', data),
  updateRequest: (id, data) => api.patch(`/api/facilities/requests/${id}`, data),
  convertRequestToWorkOrder: (id) => api.post(`/api/facilities/requests/${id}/convert-to-work-order`),
  schedules: () => api.get('/api/facilities/schedules'),
  createSchedule: (data) => api.post('/api/facilities/schedules', data),
  updateSchedule: (id, data) => api.patch(`/api/facilities/schedules/${id}`, data),
  runScheduleDueCheck: () => api.post('/api/facilities/schedules/run-due-check'),
  buildings: () => api.get('/api/facilities/buildings'),
  createBuilding: (data) => api.post('/api/facilities/buildings', data),
  updateBuilding: (id, data) => api.patch(`/api/facilities/buildings/${id}`, data),
  rooms: () => api.get('/api/facilities/rooms'),
  createRoom: (data) => api.post('/api/facilities/rooms', data),
  updateRoom: (id, data) => api.patch(`/api/facilities/rooms/${id}`, data),
  equipment: () => api.get('/api/facilities/equipment'),
  createEquipment: (data) => api.post('/api/facilities/equipment', data),
  updateEquipment: (id, data) => api.patch(`/api/facilities/equipment/${id}`, data),
  contractors: () => api.get('/api/facilities/contractors'),
  createContractor: (data) => api.post('/api/facilities/contractors', data),
  updateContractor: (id, data) => api.patch(`/api/facilities/contractors/${id}`, data),
  workOrders: () => api.get('/api/facilities/work-orders'),
  createWorkOrder: (data) => api.post('/api/facilities/work-orders', data),
  updateWorkOrder: (id, data) => api.patch(`/api/facilities/work-orders/${id}`, data),
  serviceHistory: () => api.get('/api/facilities/service-history'),
  createServiceRecord: (data) => api.post('/api/facilities/service-history', data),
  meters: () => api.get('/api/facilities/meters'),
  createMeter: (data) => api.post('/api/facilities/meters', data),
  meterReadings: () => api.get('/api/facilities/meter-readings'),
  createMeterReading: (data) => api.post('/api/facilities/meter-readings', data),
  bookings: () => api.get('/api/facilities/bookings'),
  createBooking: (data) => api.post('/api/facilities/bookings', data),
  updateBooking: (id, data) => api.patch(`/api/facilities/bookings/${id}`, data),
  inspections: () => api.get('/api/facilities/inspections'),
  createInspection: (data) => api.post('/api/facilities/inspections', data),
  updateInspection: (id, data) => api.patch(`/api/facilities/inspections/${id}`, data),
};

export default facilitiesService;